import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
export const Text = styled.span `
  ${({ theme, highlight }) => (highlight ? theme.typography.bodyBold : theme.typography.body)}
`;
// from https://stackoverflow.com/questions/29652862/highlight-text-using-reactjs
const Highlight = ({ query, text }) => {
    // no query, no need.
    if (!query.length)
        return React.createElement(Text, null, text);
    const chunks = text.split(new RegExp(`(${query})`, 'gi'));
    return (React.createElement("span", null, chunks.map((chunk, index) => (React.createElement(Text, { key: `#${chunk}#${index}`, highlight: (chunk === null || chunk === void 0 ? void 0 : chunk.toLowerCase()) === (query === null || query === void 0 ? void 0 : query.toLowerCase()) }, chunk)))));
};
Highlight.propTypes = {
    text: PropTypes.string.isRequired,
    query: PropTypes.string,
};
Highlight.defaultProps = {
    query: '',
};
export default Highlight;
//# sourceMappingURL=index.js.map